import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import TermsSection from '../components/TermsSection';



const TermsPage = () => {
  return (
    <>
    <Header />
      <TermsSection />
      <Footer />
      </>
  )
}

export default TermsPage